<template>
    <div class="homeWrap">
        <div class="line">
            <el-row :gutter="10">
                <el-col :span="12">
                    <div class="numTextBlock">
                        <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                        <div class="textBox">
                            <span class="span">订单付款总金额</span>
                            <span class="bigFont">{{payAmount}}</span>
                            <span class="span">元</span>
                        </div>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div class="numTextBlock">
                        <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                        <div class="textBox">
                            <span class="span">订单提交总金额</span>
                            <span class="bigFont">{{submitAmount}}</span>
                            <span class="span">元</span>
                        </div>
                    </div>

                </el-col>
            </el-row>
        </div>
        <div class="line echartLine">
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="colBlock" style="padding:10px 20px;">
                        <div id="echartBox" style="width: 100%;height: 410px;"></div>
                    </div>
                </el-col>
            </el-row>
        </div>


    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    import echarts from 'echarts'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                payAmount: '',
                submitAmount: '',
                chartLists: [],
                xData: [],
                numData: [],
            }
        },
        methods: {
            getDetail() {
                let _this = this
                let arg = {}
                ajaxPost('/admin/orderProfile', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.payAmount = res.data.payAmount
                        _this.submitAmount = res.data.submitAmount
                        _this.chartLists = res.data.list ? res.data.list : []
                        _this.xData = []
                        _this.numData = []
                        _this.chartLists.forEach(function(item, index) {
                            _this.xData.push(item.conference_name)
                            _this.numData.push(item.amount)
                        })
                        _this.drawPie()
                    }
                }, function(res) {

                })
            },
            drawPie() {
                let _this = this
                let charts = echarts.init(document.getElementById('echartBox'))
                let xData = _this.xData
                let option = {
                    title: {
                        text: '各活动付款总金额排名（元）',
                        // subtext: '数据来自网络'
                        textStyle: {
                                    color: "#6A89BE",
                                    fontWeight: "normal"
                        }
                    },
                    color: ['#3398DB'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'line'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                    },
                    yAxis: {
                        type: 'category',
                        data: xData,
                        axisLine: {
                            show: false
                        
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    series: [{
                            name: '金额',
                            type: 'bar',
                            barWidth: 17,
                            data: _this.numData,
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'right',
                                        formatter: '{c}' + '元'
                                    }
                                }
                            },
                        }]
                };
                charts.setOption(option)
            },
        },
        mounted() {
            this.drawPie()
            this.getDetail()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .homeWrap {
        padding:10px; max-width:1300px; margin-bottom: 50px;

        .line {
            // padding: 5px 10px;

            .colBlock {
                background: #fff;
                // padding: 20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/intro.vue